import { createSlice } from '@reduxjs/toolkit';
import { APIStatus } from '@application/enums/api-status';
import { getPartnerLogsAsync } from './partnerLogsThunk';
const initialState = {
    status: APIStatus.IDLE,
    logs: null
};
export const partnerLogsSlice = createSlice({
    name: 'partnerLogs',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getPartnerLogsAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getPartnerLogsAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.logs = action.payload;
        })
            .addCase(getPartnerLogsAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
    }
});
export default partnerLogsSlice.reducer;
